import { Tooltip } from 'antd'
import { BpButton } from '../../../../shared/components/buttons/bp-button/BpButton'
import { IconPlus } from '../../../../shared/components/icons/IconPlus'
import { IconUnlink } from '../../../../shared/components/icons/IconUnlink'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

interface NameCellProps {
  name: string
  id: number
  has_active_affrules: boolean
}

export const NameCell = ({ name, id, has_active_affrules }: NameCellProps) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <div className={'flex items-center gap-[4px]'}>
      <div className={'w-[185px] truncate'}>{name}</div>
      {!has_active_affrules && (
        <Tooltip
          title={
            <div className={'flex flex-col gap-[16px]'}>
              <p className={'text-white'}>{t('pages.projects.affiliateTrackingNotSetUp')}</p>
              <BpButton
                className={'w-fit !bg-white'}
                contentClassName={'text-[#00326D]'}
                iconLeft={<IconPlus color={'#00326D'} />}
                size={'sm'}
                theme={'light'}
                onClick={() => {
                  navigate(`/projects/${id}/affiliate-tracking`)
                }}
              >
                {t('pages.projects.buttons.setUpTracking')}
              </BpButton>
            </div>
          }
        >
          <div className={'w-[20px] rounded-full bg-[#ff497d] p-[3px]'}>
            <IconUnlink color={'#FFFFFF'} />
          </div>
        </Tooltip>
      )}
    </div>
  )
}
